import React, { useState } from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
import { toast } from 'react-toastify';
import validator from 'validator';
import { login, loginVerifyCode } from "../../../services/AuthService";
import Utils from "../../../utils";
import { CLIENT_LOCAL_STORE, SALT } from "../../../configs/AppConfig";
import { encryptData } from "../../../utils/crypto";
import { Lang } from "../../../lang";
import { useGoogleLogin } from '@react-oauth/google';
import Logo from '../../../assets/Images/Docusafe_logo.webp';
import './AuthPages.css';


function Login() {
    document.title = Lang.login_title;
    document.getElementsByTagName("META")[4].content = Lang.login_meta_desc;
    document.getElementsByTagName("META")[5].content = Lang.login_meta_keyword;

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [isVerify, setIsVerify] = useState(false);
    const [userData, setUserData] = useState({});
    const [code, setCode] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);

    let errorsObj = { email: '', password: '', code: '' };
    const [errors, setErrors] = useState(errorsObj);

    function onLogin(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter valid email address';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is required';
            error = true;
        }
        setErrors(errorObj);
        if (error) return;
        setLoading(true);
        let obj = {
            email: email,
            password: password
        };
        login(obj)
            .then(response => {
                if (response.data.data.qr_code) {
                    setIsVerify(true);
                    setLoading(false);
                    setUserData(response.data.data);
                } else {
                    let encryptedData = encryptData(response.data.data, SALT);
                    localStorage.setItem(CLIENT_LOCAL_STORE, encryptedData);
                    navigate('/client-portal');
                    setLoading(false);
                }
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    }

    const onVerify = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (!code) {
            errorObj.code = 'Code is required';
            error = true;
        }
        setErrors(errorObj);
        if (error) return;
        setLoading(true);
        let data = { ...userData };
        let obj = {
            id: (data.id),
            company_login_id: (data.company_user_id),
            code: code
        };
        loginVerifyCode(obj)
            .then(response => {
                let encryptedData = encryptData(userData, SALT);
                localStorage.setItem(CLIENT_LOCAL_STORE, encryptedData);
                setLoading(false);
                navigate('/client-portal');
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    };

    return (
        <div className="login-container">
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}
            {/* Logo at the top */}
            <img src={Logo} alt="Logo" className="login-logo" />
            <div 
                className="auth-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
              
                <h3 className="login-title">{isVerify ? `Two Factor Authentication Code` : `Login`}</h3>
                {isVerify ? (
                    <form 
                    onSubmit={onVerify}
                    className="auth-form"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                >
                        <div className="">
                            <label className="form-label mb-2">Google Authenticator App Code</label>
                            <input
                                type="number"
                                className="form-control focus:outline-none"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="Enter 6-digit code"
                            />
                            {errors.code && <div className="login-error">{errors.code}</div>}
                        </div>
                        <button type="submit" className="login-btn-page btn w-100 mb-3">Verify</button>
                    </form>
                ) : (
                    <form 
                    onSubmit={onLogin}
                    className="auth-form"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    >
                        <div className="">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input
                                type="text"
                                className="form-control focus:outline-none"
                                id="email"
                                value={email}
                                maxLength="50"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="user@example.com"
                            />
                            {errors.email && <div className="login-error">{errors.email}</div>}
                        </div>
                        <div className="mb-3">
                            <div className="d-flex justify-content-between mb-2">
                                <label htmlFor="password" className="form-label">Password</label>
                                <Link to='/forgot-password' className="login-link">Forgot Password?</Link>
                            </div>
                            <div className="position-relative">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    className="form-control focus:outline-none"
                                    value={password}
                                    maxLength="15"
                                    onChange={(e) => setPassword(e.target.value)}
                                    id="password"
                                />
                                <span
                                    className="password-toggle"
                                    onClick={() => setPasswordVisible(!passwordVisible)}
                                >
                                    <i className={`bi ${passwordVisible ? 'bi-eye-slash' : 'bi-eye'}`} style={{ fontSize: '1.2rem' }}></i>
                                </span>
                            </div>
                            {errors.password && <div className="login-error">{errors.password}</div>}
                        </div>
                        <button type="submit" className="login-btn-page w-100 mb-3">Login</button>
                        <p className="text-center">Don't have an account? <NavLink to="/sign-up" className="login-link">Register</NavLink> instead.</p>
                    </form>
                )}
            </div>
        </div>
    );
}

export default Login;
     